import { Link } from 'react-router-dom';
import './../../pages/properties/property.css';
import _ from 'lodash';
import { arrayAny } from '../../utils/arrayUtils';

export const PropertyTiles = (props) => {

    const primaryImagePath = (property) => {
        const primary = _.first(_.filter(property.photoGallery, p => p.isPrimaryImage));
        return primary && primary.pathIncSASToken ? primary.pathIncSASToken : null;
    }

    const imageNotAvailableClass = (property) => {
        const result = "property product" + (primaryImagePath(property) ? "" : " not-available");
        return result;
    }

    const imageStyle = (property) => {
        const unknown = { marginTop: "20px", alignSelf: "center", width: "50%", backgroundImage: 'url(/assets/img/pos/unknown-house.png)' };
        const known = { backgroundImage: `url(${primaryImagePath(property)})` };
        return primaryImagePath(property) ? known : unknown;
    }

    return (arrayAny(props.properties) && props.properties.map((propertyDoc, p) => (

        <div key={`property-${propertyDoc.id}-counter-${p}`} className="product-container" >
            <Link to={`/property/detail/${propertyDoc.id}`} className={imageNotAvailableClass(propertyDoc.property)}>
                <div className="img" style={imageStyle(propertyDoc.property)}></div>
                <div className="text">
                    <div className="property-description">{propertyDoc.property.name}</div>
                    <div className="property-first-line">{propertyDoc.property.address.doorNumberOrName} {propertyDoc.property.address.roadName}</div>
                    <div className="property-first-line">{propertyDoc.property.landlordOrOwner.displayName}</div>
                    <div className="postcode">{propertyDoc.property.address.town}, {propertyDoc.property.address.postalCode}</div>
                </div>
                {!primaryImagePath(propertyDoc.property) && (
                    <div className="not-available-text">
                        <div>Image Not Available</div>
                    </div>
                )}
            </Link>
        </div>
    ))
    );
}